import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'opac-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss']
})
export class ProgressSpinnerComponent implements AfterViewInit {
  private static readonly STROKE_DASHARRAY = 282.743;

  private _progress = 0;

  @ViewChild('spinnerProgress') spinnerProgress!: ElementRef<SVGCircleElement>;

  @Input() progressText: string;
  @Input() set progress(value: number) {
    this._progress = value;
    this.progressText = this.progressText ?? '';
    this.updateSpinnerWithProgress(value);
  }
  get progress(): number {
    return this._progress;
  }

  constructor() { }

  ngAfterViewInit(): void {
    this.updateSpinnerWithProgress(this._progress);
  }

  clamp(a: number, min = 0, max = 1) {
    return Math.min(max, Math.max(min, a));
  }

  private updateSpinnerWithProgress(progress: number) {
    if (!this.spinnerProgress) {
      return;
    }

    // Linear interpolation function
    const lerp = (x: number, y: number, a: number) => x * (1 - a) + y * a;
    const clamp = (a: number, min = 0, max = 1) => Math.min(max, Math.max(min, a));
    this.spinnerProgress.nativeElement.style.strokeDashoffset = Math.round(lerp(ProgressSpinnerComponent.STROKE_DASHARRAY, 0, clamp(progress, 0, 100) / 100)) + 'px';
  }
}
